// extracted by mini-css-extract-plugin
export default {"inputWrapper":"Dropdown_inputWrapper__ZAWBh","label":"Dropdown_label__aBB00","select":"Dropdown_select__sAede","sm":"Dropdown_sm__Efkn+"};